var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "function-detail-panel" }, [
    _c("label", { staticClass: "section-label" }, [
      _vm._v(_vm._s(_vm.selectedFunction.name || "函数说明")),
    ]),
    _c("div", { staticClass: "function-detail-content" }, [
      _vm.selectedFunction
        ? _c("div", { staticClass: "function-detail" }, [
            _c("div", { staticClass: "function-syntax" }, [
              _vm._v(_vm._s(_vm.selectedFunction.syntax)),
            ]),
            _c("div", { staticClass: "function-description" }, [
              _vm._v(_vm._s(_vm.selectedFunction.description)),
            ]),
            _vm.selectedFunction.example
              ? _c("div", { staticClass: "function-example" }, [
                  _c("div", { staticClass: "example-label" }, [
                    _vm._v("示例："),
                  ]),
                  _c("div", { staticClass: "example-content" }, [
                    _vm._v(_vm._s(_vm.selectedFunction.example)),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "no-selection" }, [
            _vm._v("选择一个函数查看详细说明"),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }